import { withPrefix } from 'gatsby';
import React, { FunctionComponent, MouseEvent, useContext } from 'react';
import Context from '../../context/Context';
import { useGatedLinkModalContext } from '../../context/GatedLinkModalProvider';
import { AuthLinkProps } from '../../interfaces/interfaces';
import { StyledGatedModal } from '../styled';

interface GatedLinkProps extends AuthLinkProps {
  closeNav?: () => void;
}

const GatedLink: FunctionComponent<GatedLinkProps> = (
  props: GatedLinkProps
) => {
  const { activeModal, setActiveModal } = useGatedLinkModalContext();
  const modalId = props.to;
  const data = useContext(Context);
  const { siteName } = data;

  const handleOnClick = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    setActiveModal(modalId);

    if (props.closeNav) {
      props.closeNav();
    }
  };

  const handleClose = () => {
    setActiveModal(null);
  };

  const isOpen = activeModal === modalId;

  return (
    <>
      <a
        onClick={handleOnClick}
        className={props.className}
        href={withPrefix(props.to)}
        target={props.target}
      >
        {props.children}
      </a>
      {isOpen && (
        <StyledGatedModal
          open={isOpen}
          onClose={handleClose}
          className="gated-modal"
        >
          <div className="sng-container" style={{ background: '#fff' }}>
            <h2>{siteName}</h2>
            <p>
              <span style={{color: '#000'}}>{props.children} Coming Soon</span>
            </p>
            <button onClick={() => handleClose()}>OK</button>
          </div>
        </StyledGatedModal>
      )}
    </>
  );
};

export default GatedLink;
